module.exports = __webpack_public_path__ + "6d6aefa9b20610ea515b7439902dc3bc.svg";